import { combineReducers } from '@reduxjs/toolkit'
import atlasSandReducer from './AtlasSandReducer'
import userRolesReducer from './UserRolesReducer'
import rolesManagementReducer from './rolesManagementReducer'
import { authApi } from '../../api/auth/AuthApi'
import { apiService } from '../../api/apiService'

const rootReducer = combineReducers({
  atlas: atlasSandReducer,
  userRole: userRolesReducer,
  roleCapabilities: rolesManagementReducer,
  [authApi.reducerPath]: authApi.reducer,
  [apiService.reducerPath]: apiService.reducer,
})

export default rootReducer
